import styled from "styled-components";
import {GameNavBarButtonLabelDefaultBox} from "./game-nav-bar-button-label.default.box";

export const GameNavBarButtonLabelCasino777Box = styled(GameNavBarButtonLabelDefaultBox)`
    font-weight: 300;
`;